import type { IEnvironmentService } from '../environment/environment.interface';

export const apiStartsWith = (env: IEnvironmentService, url: string, startsWithPath: string): boolean => {
	url = url.trim().toLowerCase();

	// Safely derive the pathname — supports both absolute and relative URLs
	let path = '';
	let origin = '';

	try {
		const urlObj = url.startsWith('http') ? new URL(url) : new URL(url, env.api); // resolves relative paths against API base
		path = urlObj.pathname;
		origin = urlObj.origin;
	} catch {
		path = '';
		origin = '';
	}

	// Only handle API calls that match the specified path
	return origin.includes(env.api) && path.startsWith(startsWithPath);
};
